<template>
  <PageSection
    class="training-section-icon-blocks-accordion"
    :class="{ 'has-bottom-line': showBottomLine }"
  >
    <template #default>
      <div class="container">
        <h2
          v-if="title"
          class="title"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 300}"
          v-html="title"
        ></h2>
        <div
          v-if="programs && programs.length"
          class="programs-accordion"
          v-inview-animate:once="{name: 'fade-down', duration: 500, delay: 400}"
        >
          <TrainingSectionProgramItem
            v-for="(program, index) in programs"
            :key="`program-${index}`"
            :name="program.Name"
            :icon-blocks="program.IconBlocks"
            :open-by-default="program.OpenByDefault"
          />
        </div>
      </div>
    </template>
  </PageSection>
</template>

<script>
import PageSection from '@/components/PageSection.vue';
import TrainingSectionProgramItem from './TrainingSectionProgramItem.vue';

export default {
  name: 'TrainingSectionIconBlocksAccordion',
  components: {
    PageSection,
    TrainingSectionProgramItem,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    programs: {
      type: Array,
      default: () => [],
    },
    showBottomLine: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.training-section-icon-blocks-accordion {
  &.has-bottom-line {
    border-bottom: 1px solid color(dark);
  }

  @include wRule(
    padding-top,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  @include wRule(
    padding-bottom,
    (
      xl: 120,
      lg: 100,
      md: 80,
      sm: 80,
    )
  );

  .title {
    display: block;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.02em;

    @include wRule(
      font-size,
      (
        xl: 65,
        lg: 50,
        md: 45,
        sm: 65,
      )
    );

    @include wRule(
      max-width,
      (
        xl: 1095,
        lg: 800,
        md: 700,
        sm: 100%,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 48,
          lg: 40,
          md: 32,
          sm: 40,
        )
      );
    }
  }

  .programs-accordion {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
}
</style>
